import React from "react";
import { getPageSection } from "../data-helpers";
import { VALoansPageData, VAPageSection } from "../types";
import Spacer from "@eave/shared/components/Spacer";
import { EMDASH } from "@eave/shared/utils";

interface Props {
  section: VAPageSection;
  data: VALoansPageData;
}

const styles = require("./styles.module.scss");

const displayValue = (v: any): string => {
  let str;

  const shouldDisplayEmptyValue = v === null || v === undefined || v.length === 0;
  if (shouldDisplayEmptyValue) {
    str = EMDASH;
  } else if (typeof v === "boolean") {
    str = v ? "Yes" : "No";
  } else {
    str = `${v}`;
  }

  return str;
};

const PageSection: React.FC<Props> = ({ section, data }: Props) => {
  const dataForSection = getPageSection(data, section);
  return (
    <section className={styles.pageSection}>
      {section && <h3 className={styles.sectionHeading}>{section}</h3>}
      <Spacer />
      <div className={styles.fieldsContainer}>
        {dataForSection.map(({ key, label, value }) => (
          <div key={key} className={styles.field}>
            <span>{label}</span>
            <p>{displayValue(value)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PageSection;
